import React, { useState, useEffect } from "react";

import { Link, useParams, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";

import AuthModel from "../../models/Auth";
import useAuthUser from "../../utils/AuthUser";
import { setAlert, setHiddenSidebar } from "../../store/app";

import SpaceReference from "./SpaceReference";
import PlanReference from "../app/payment/PlanReference";
import { useTranslation } from "react-i18next";

import {
  TextInput,
  Paper,
  Title,
  Text,
  Container,
  Button,
  Box,
  Divider,
  Stepper,
  Grid,
  ScrollArea,
} from "@mantine/core";

import { useForm } from "@mantine/form";

import { useMediaQuery } from "@mantine/hooks";

import { Helmet } from "react-helmet";

export default function MagicLink(props) {
  const { t, i18n } = useTranslation();

  const params = useParams();

  const dispatch = useDispatch();
  const queryParams = useLocation().search;

  const { setAuthUser } = useAuthUser();

  const form = useForm({
    initialValues: {
      email: "",
    },

    validate: {
      email: (value) =>
        /^\S+@\S+$/.test(value.trim())
          ? null
          : t("users.magicLink.invalidEmailErrorMsg"),
    },
  });

  const [spaceReference, setSpaceReference] = useState();
  const [planReference, setPlanReference] = useState();
  const [showStepper, setStepper] = useState(false);
  const [showSpaceReference, setShowSpaceReference] = useState(true);

  const [dialog, setDialog] = useState({
    opened: false,
    title: "",
    message: "",
    color: "indigo",
  });

  useEffect(() => {
    const b = document.getElementsByTagName("body")[0];
    b.style.display = "none";
    dispatch(setHiddenSidebar({ hidden: true }));
    setTimeout(() => {
      const b = document.getElementsByTagName("body")[0];
      b.style.display = "";
      dispatch(setHiddenSidebar({ hidden: true }));
    }, 250);
    return () => {
      dispatch(setHiddenSidebar({ hidden: false }));
    };
  }, []);

  useEffect(() => {
    const spaceReference = new URLSearchParams(queryParams).get("s");
    const planReference = new URLSearchParams(queryParams).get("p");
    let email = new URLSearchParams(queryParams).get("email");
    email = email === null ? "" : email.replace(/ /g, "+");
    form.setFieldValue("email", email);
    setSpaceReference(spaceReference);
    setPlanReference(planReference);
  }, [queryParams]);

  const onMagicLink = () => {
    const email = form.values.email.trim();
    AuthModel.onMagicLink(
      email,
      { slug: spaceReference, plan: planReference },
      (data) => {
        // Success callback
        dispatch(
          setAlert({
            opened: true,
            title: data.title,
            message: data.message,
            color: "green",
          })
        );
        form.setFieldValue("email", "");
      },
      (data) => {
        // Error callback
        dispatch(
          setAlert({
            opened: true,
            title: data.title,
            message: data.message,
            color: "red",
          })
        );
      }
    );
  };

  const smallScreen = useMediaQuery("(max-width: 768px)");

  return (
    <ScrollArea style={{ height: "100%" }}>
      <Helmet>
        <title>{`Sutra - Magic link`}</title>
      </Helmet>
      <Container style={{ marginBottom: "50px" }} size={1000}>
        {!smallScreen && spaceReference && showStepper ? (
          <Container size={800} mt={30} align="center">
            <Stepper active={0} breakpoint="sm" size="lg">
              <Stepper.Step
                label={t("users.stepper.step1")}
                description={t("users.stepper.step1Description")}
              ></Stepper.Step>
              <Stepper.Step
                label={t("users.stepper.step2")}
                description={t("users.stepper.step2Description")}
              ></Stepper.Step>
              <Stepper.Step
                label={t("users.stepper.step3")}
                description={t("users.stepper.step3Description")}
              ></Stepper.Step>
            </Stepper>
          </Container>
        ) : (
          ""
        )}
        <Grid justify="center" grow gutter="0">
          <Grid.Col xs={12} sm={6}>
            <Container size={500} my={40}>
              <form onSubmit={form.onSubmit((values) => onMagicLink(values))}>
                <Paper withBorder shadow="md" p={0} mt={30} radius="md">
                  <Box pt={20} pb={5} pl={35} pr={35}>
                    <Title sx={(theme) => ({ fontSize: 28, fontWeight: 900 })}>
                      {t("users.magicLink.title")}
                    </Title>
                    <Text color="dimmed" size="md">
                      {t("users.magicLink.subtitle")}
                    </Text>
                  </Box>
                  <Divider
                    sx={(theme) => ({ borderTopColor: theme.colors.gray[2] })}
                    my="sm"
                  />
                  <Box pt={10} pb={25} pl={35} pr={35}>
                    <TextInput
                      required
                      {...form.getInputProps("email")}
                      label={t("users.magicLink.email")}
                      radius="sm"
                      size="md"
                      mb={15}
                    />
                    <Button
                      fullWidth
                      mt="xl"
                      radius="xl"
                      size="md"
                      mb={15}
                      type="submit"
                    >
                      {t("users.magicLink.submit")}
                    </Button>
                    <Divider
                      sx={(theme) => ({
                        borderTopColor: theme.colors.gray[2],
                        color: theme.colors.gray[2],
                      })}
                      my="sm"
                      label="OR"
                      labelPosition="center"
                      labelProps={{ color: "#666" }}
                    />
                    <Text size="md" align="center" mt={15}>
                      <Link to={"/user/sign_in" + queryParams}>
                        {t("users.magicLink.footer")}
                      </Link>
                    </Text>
                  </Box>
                </Paper>
              </form>
            </Container>
          </Grid.Col>
          {spaceReference && showSpaceReference && (
            <Grid.Col xs={12} sm={6}>
              <SpaceReference
                slug={spaceReference}
                setSpaceReference={setSpaceReference}
                setShowSpaceReference={setShowSpaceReference}
                setStepper={setStepper}
              />
            </Grid.Col>
          )}
          {planReference && (
            <Grid.Col xs={12} sm={6}>
              <PlanReference plan={planReference} />
            </Grid.Col>
          )}
        </Grid>
      </Container>
    </ScrollArea>
  );
}
